import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("authUser"));
  const isAdmin = user.role == 'Admin' ? true : false; 
  //state data
  const [isVehicles, setIsVehicles] = useState(false);
  const [isParts, setIsParts] = useState(false);
  const [isNotes, setIsNotes] = useState(false);
  const [isFinances, setIsFinances] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id)) document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Vehicles") {
      setIsVehicles(false);
    }
    if (iscurrentState !== "Parts") {
      setIsParts(false);
    }
    if (iscurrentState !== "Notes") {
      setIsNotes(false);
    }
    if (iscurrentState !== "Finances") {
      setIsFinances(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
  }, [history, iscurrentState, isVehicles, isParts, isNotes, isFinances, isAuth, isPages]);

  const adminMenu = [
    {
      label: "Skladište",
      isHeader: true,
    },
    {
      id: "parts",
      label: "Dijelovi",
      icon: "bx bx-wrench",
      link: "/parts",
      click: function (e) {
        e.preventDefault();
        setIsParts(!isParts);
        setIscurrentState("Parts");
        updateIconSidebar(e);
        history("/parts");
      },
      stateVariables: isParts,
    },
    {
      id: "vehicles",
      label: "Vozila",
      icon: "bx bxs-car",
      link: "/vehicles",
      stateVariables: isVehicles,
      click: function (e) {
        e.preventDefault();
        setIsVehicles(!isVehicles);
        setIscurrentState("Vehicles");
        updateIconSidebar(e);
        history("/vehicles");
      },
    },
    {
      label: "Administracija",
      isHeader: true,
    },
    {
      id: "notes",
      label: "Bilješke",
      icon: "bx bx-note",
      link: "/notes",
      click: function (e) {
        e.preventDefault();
        setIsNotes(!isNotes);
        setIscurrentState("Notes");
        updateIconSidebar(e);
      },
      stateVariables: isNotes,
    },
    {
      id: "finances",
      label: "Finansije",
      icon: "bx bx-file",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsFinances(!isFinances);
        setIscurrentState("Finances");
        updateIconSidebar(e);
      },
      stateVariables: isFinances,
      subItems: [
        {
          id: "statistics",
          label: "Statistika",
          link: "/finances",
          parentId: "finances",
        },
        {
          id: "reports",
          label: "Izvještaji",
          link: "/finance-reports",
          parentId: "finances",
        }
      ]
    }
  ];
  const menuItems = [
    {
      label: "Skladište",
      isHeader: true,
    },
    {
      id: "parts",
      label: "Dijelovi",
      icon: "bx bx-wrench",
      link: "/parts",
      click: function (e) {
        e.preventDefault();
        setIsParts(!isParts);
        setIscurrentState("Parts");
        updateIconSidebar(e);
        history("/parts");
      },
      stateVariables: isParts,
    },
    {
      id: "vehicles",
      label: "Vozila",
      icon: "bx bxs-car",
      link: "/vehicles",
      stateVariables: isVehicles,
      click: function (e) {
        e.preventDefault();
        setIsVehicles(!isVehicles);
        setIscurrentState("Vehicles");
        updateIconSidebar(e);
        history("/vehicles");
      },
    }
  ];

  return <React.Fragment>{isAdmin ? adminMenu : menuItems}</React.Fragment>;
};
export default Navdata;